import { mdiAccount, mdiMapMarker } from "@mdi/js"
import {
  buildViewNavigation,
  type PageTabWithId,
  type ViewPageSnippets,
  type ViewPageSpec,
} from "@kontextwerk/web-sdk/core/navigation/viewNavigation"
import type { PermissionState } from "@kontextwerk/control-web-frame/logic/permissions/model"

type CustomersViewFrameContext = {
  permissions: PermissionState
}

export type CustomerDetailViewPaths = {
  details: string
  priorities: string
  contacts: string
  availability: string
  addresses: string
}

export const buildCustomerDetailViewPaths = (basePath: string): CustomerDetailViewPaths =>
  basePath
    ? {
        details: `${basePath}/details`,
        priorities: `${basePath}/priorities`,
        contacts: `${basePath}/contacts`,
        availability: `${basePath}/availability`,
        addresses: `${basePath}/addresses`,
      }
    : {
        details: "",
        priorities: "",
        contacts: "",
        availability: "",
        addresses: "",
      }

const getCustomerDetailsTabs = (_ctx: CustomersViewFrameContext): PageTabWithId[] => [
  { id: "details", title: "Ansprechpartner" },
  { id: "contacts", title: "Kontaktdaten" },
  { id: "availability", title: "Verfügbarkeiten" },
]

const getAddressesTabs = (_ctx: CustomersViewFrameContext): PageTabWithId[] => [
  { id: "addresses", title: "Einheiten" },
]

const PAGE_SPECS: Array<ViewPageSpec<CustomersViewFrameContext, CustomerDetailViewPaths>> = [
  {
    id: "customerDetails",
    title: "Ansprechpartner",
    icon: mdiAccount,
    resolvePath: (paths) => paths.details,
    getTabs: getCustomerDetailsTabs,
  },
  {
    id: "addresses",
    title: "Einheiten",
    icon: mdiMapMarker,
    resolvePath: (paths) => paths.addresses,
    getTabs: getAddressesTabs,
  },
]

export const buildCustomerDetailViewNavigation = ({
  context,
  paths,
  snippets,
}: {
  context: CustomersViewFrameContext
  paths: CustomerDetailViewPaths
  snippets: ViewPageSnippets
}) =>
  buildViewNavigation({
    specs: PAGE_SPECS,
    context,
    paths,
    capabilities: null,
    snippets,
  })
